import type { IntegrationRequestDetail } from '../../../../models/IntegrationRequest';
import DetailCard from './DetailCard';

type RequestBranchesCardProps = Pick<IntegrationRequestDetail, 'branches' | 'allBranches'>;

const RequestBranchesCard = ({ branches, allBranches }: RequestBranchesCardProps) => (
  <DetailCard
    title={
      <>
        Sucursales {allBranches && <span className='text-gray-500 font-normal'>(todas)</span>}
      </>
    }
  >
    <ul className='text-sm text-gray-800 flex flex-col gap-1'>
      {branches.map((branch) => (
        <li key={branch.id}>
          {branch.name}{' '}
          {branch.externalBranchCode ? (
            <span className='text-gray-500'>
              · código {branch.externalBranchCode}
              {branch.apiCode && ` (${branch.apiCode})`}
            </span>
          ) : (
            <span className='text-amber-700'>· sin código</span>
          )}
        </li>
      ))}
    </ul>
  </DetailCard>
);

export default RequestBranchesCard;
